import { useGetLayoutByStatus } from '@vindr/services/actions/layout.action';
import keycloak from '@vindr/services/keycloak';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface ProcedureGroup extends FormItemProps {
  institution_ids?: Parameters<typeof useGetLayoutByStatus>[0]['institution_ids'];
  status?: Parameters<typeof useGetLayoutByStatus>[0]['status'];
}

const LayoutList = ({
  name = 'layout_id',
  label = 'Layout List',
  placeholder = 'Select Layout List',
  rules,
  multiple = false,
  required = false,
  onChange,
  disabled,
  institution_ids,
  status,
  ...props
}: ProcedureGroup) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const userInfo = keycloak.getUserInfo();

  const {
    data: layoutList,
    isInitialLoading,
    isFetching,
  } = useGetLayoutByStatus({
    institution_ids,
    name: searchTerm,
    status,
    user_ids: [userInfo?.id],
  });

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, ...props }}
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isFetching}
      {...(rules || (required && { rules: rulesMemo }))}
      onChange={onChange}
      onSearch={handleSearch}
      showSearch
    >
      {layoutList?.map((layout) => (
        <Select.Option key={layout.id} value={layout.id}>
          {layout.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default LayoutList;
